import React, { Component } from 'react';
import injectSheet from 'react-jss';
import commonStyle from '../styles/common';
import axios from 'axios';
import { isValidURL } from 'h-commons';

class UserAvatar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            avatarUrl: null
        }
    }

    componentDidMount() {
        const { avatarUrl } = this.props;
        this.setState({ avatarUrl })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.avatarUrl !== this.state.avatarUrl)
            this.setState({ avatarUrl: nextProps.avatarUrl })
    }

    resetAvatarUrl() {
        this.setState({ avatarUrl: null });
    }

    render() {
        const { name, avatarColor, type, isInvited, additionalClass } = this.props;
        const anotherClass = additionalClass ? additionalClass : "";
        const { hAvatar, invitedAvatar } = this.props.classes;
        const { avatarUrl } = this.state;
        if (avatarUrl) {
            return (
                <img
                    src={`${avatarUrl}`}
                    onError={this.resetAvatarUrl.bind(this)}
                    className={`${hAvatar} ${anotherClass}`}
                />
            );
        }
        if (!avatarUrl && name && typeof name === 'string') {
            return (
                <span className={`${invitedAvatar} ${anotherClass}`}
                    style={{ backgroundColor: avatarColor }}>
                    {name.charAt(0).toUpperCase()}
                </span>
            );
        }
        return (
            <span
                className={`${invitedAvatar} ${anotherClass}`}
                style={{ backgroundColor: "#f8f8f8" }}>
            </span>
        );
    }
}

export default injectSheet(commonStyle)(UserAvatar);